import axios from 'axios';
import config from '../config';
import { showError } from '../utils';
import LogRocket from 'logrocket';
import { store } from '../store';
import { refreshAxiosInstance } from '../utils/axiosInstance';
import { logEvent } from '../utils/logEvent';

export function login(
  phoneNumber,
  countryCode,
  encData,
  resend,
  platform,
  ssoInfo,
  storedUTMParams,
  emailCode = null,
  emailVerificationId = null,
  channel = null
) {
  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      const body = {
        phone: phoneNumber,
        countryCode,
        platform: 'PHONEPE',
        emailCode,
      };
      if (resend) {
        body['resend'] = true;
      }
      return axios
        .post(`${config.apiBaseUrl}/new-auth/login-phone`, body)
        .then((resp) => {
          const responseBody = resp.data;
          if (responseBody.message === 'otpSent') {
            return responseBody;
          }
          const err = new Error('Invalid response');
          err.data = responseBody;
          showError(err);
          throw err;
        })
        .catch((err) => {
          showError(err);
          throw err;
        });
    })
    .catch((err) => {
      const body = channel
        ? {
            channel,
            resend,
            countryCode,
            phone: phoneNumber,
            platform: 'WEB',
          }
        : {
            phone: phoneNumber,
            countryCode,
            platform: platform || 'WEB',
            encData,
            ssoInfo,
            storedUTMParams,
            emailCode,
            evId: emailVerificationId,
            ...(resend && { resend: true }),
          };

      return axios
        .post(`${config.apiBaseUrl}/new-auth/login-phone`, body)
        .then((resp) => {
          const responseBody = resp.data;
          if (responseBody.message === 'otpSent') {
            return responseBody;
          }
          const err = new Error('Invalid response');
          err.data = responseBody;
          showError(err);
          throw err;
        })
        .catch((err) => {
          showError(err);
          throw err;
        });
    });
}

export function loginMagicLink(magicLink, platform) {
  const body = {
    installReferrer: magicLink,
    platform: platform || 'WEB',
  };
  return axios
    .post(`${config.apiBaseUrl}/new-auth/magic`, body)
    .then((resp) => {
      const responseBody = resp.data;
      const responseHeaders = resp.headers;
      if (responseBody.message === 'success') {
        console.log('@@@@@@', responseBody);
        return {
          headers: responseHeaders,
          body: responseBody,
        };
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function loginPhonepe(grantToken) {
  const body = {
    grantToken,
  };
  return axios
    .post(`${config.apiBaseUrl}/new-auth/phonepe/sso`, body)
    .then((resp) => {
      const responseBody = resp.data;
      const responseHeaders = resp.headers;
      if (responseBody.message === 'success') {
        return {
          headers: responseHeaders,
          body: responseBody,
        };
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      showError(err);
      throw err;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function verifyOtp(
  phoneNumber,
  otp,
  platform,
  ssoInfo,
  emailCode = null
) {
  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      const body = {
        phone: phoneNumber,
        otp,
        platform: 'PHONEPE',
        emailCode,
      };
      return axios
        .post(`${config.apiBaseUrl}/new-auth/otp`, body, {
          withCredentials: true,
        })
        .then((resp) => {
          console.log(resp, 'resp in verify otp 123');
          const responseBody = resp.data;
          const responseHeaders = resp.headers;

          if (responseBody.message === 'otpVerified') {
            return {
              headers: responseHeaders,
              body: responseBody,
            };
          }
          const err = new Error('Invalid response');
          err.data = responseBody;
          throw err;
        });
    })
    .catch((err) => {
      if (err.message === 'Invalid response') {
        throw err;
      } else {
        const body = {
          phone: phoneNumber,
          otp,
          platform: platform || 'WEB',
          referrer: window.baseLandingUrl,
          ssoInfo,
          emailCode,
        };
        return axios
          .post(`${config.apiBaseUrl}/new-auth/otp`, body)
          .then((resp) => {
            console.log(resp, 'resp in verify otp 456');
            const responseBody = resp.data;
            const responseHeaders = resp.headers;
            if (responseBody.message === 'otpVerified') {
              return {
                headers: responseHeaders,
                body: responseBody,
              };
            }
            const err = new Error('Invalid response');
            err.data = responseBody;
            throw err;
          });
      }
    });
}

export function verifyEmailOTP(
  email,
  otp,
  platform,
  ssoInfo,
  emailCode = null
) {
  const token = store.getState().user.authToken;
  const otpVerifier = store.getState().app.emailOtpVerifier;
  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      const body = {
        email,
        otp,
        platform: 'PHONEPE',
        otpVerifier,
        emailCode,
      };
      return axios
        .post(`${config.apiBaseUrl}/new-auth/verify-email-otp`, body, {
          headers: {
            Authorization: token,
          },
        })
        .then((resp) => {
          console.log(resp, 'resp in verify otp 123');
          const responseBody = resp.data;
          const responseHeaders = resp.headers;
          if (responseBody.message === 'success') {
            // logEvent('Onboarding OTP Verified');
            return {
              headers: responseHeaders,
              body: responseBody,
            };
          }
          const err = new Error('Invalid response');
          err.data = responseBody;
          throw err;
        });
    })
    .catch((err) => {
      if (err.message === 'Invalid response') {
        throw err;
      } else {
        const body = {
          email,
          otp,
          platform: platform || 'WEB',
          referrer: window.baseLandingUrl,
          otpVerifier,
        };
        return axios
          .post(`${config.apiBaseUrl}/new-auth/verify-email-otp`, body, {
            headers: {
              Authorization: token,
            },
          })
          .then((resp) => {
            console.log(resp, 'resp in verify otp 456');
            const responseBody = resp.data;
            const responseHeaders = resp.headers;
            if (responseBody.message === 'success') {
              return {
                headers: responseHeaders,
                body: responseBody,
              };
            }
            const err = new Error('Invalid response');
            err.data = responseBody;
            throw err;
          });
      }
    });
}

export function submitUserDetails(name, dob, gender, authToken) {
  const body = {
    name,
    dob,
    gender,
  };

  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/new-auth/register-details`, body, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'userUpdated') {
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function userInfo(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/new-auth/login-info?v=123`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      const responseCode = resp.status;
      if (responseCode === 200 || responseCode === 304) {
        /**
         * Identify user for Log Rocket sessions
         */
        if (responseBody?.userInfo?.userId) {
          // If user id found then identify user
          LogRocket.identify(responseBody.userInfo.userId, {
            name: responseBody.userInfo.userName,
            email: responseBody.userInfo.userEmail,
          });
        }
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function markSmartSummaryShown(authToken, caseId) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(
      `${config.apiBaseUrl}/new-auth/smart-summary/bottom-sheet/mark-shown`,
      { caseId },
      { headers }
    )
    .then((resp) => resp.data)
    .catch((err) => {
      showError(err);
    });
}

export function appConfig(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/new-auth/config`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function verifyCorporate(email, authToken) {
  const body = {
    email,
  };

  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/new-auth/verify-b2b`, body, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (
        responseBody.message === 'sponsorFound' ||
        responseBody.message === 'ssoAuthentication' ||
        responseBody.message === 'emailOTPVerification'
      ) {
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}
export function sendEmailVerificationLink(email, resend = false) {
  const body = {
    email,
  };

  let url = `${config.apiBaseUrl}/new-auth/email-signup`;
  if (resend) {
    url = `${config.apiBaseUrl}/new-auth/resend-email-verification`;
  }
  return axios
    .post(url, body, {})
    .then((resp) => {
      let responseBody = resp.data;

      if (responseBody.message === 'success') {
        if (resp?.headers?.authorization) {
          responseBody = {
            ...responseBody,
            authorization: resp?.headers?.authorization,
          };
        }
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function confirmEmail(email, authToken) {
  const body = {
    email,
  };

  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/new-auth/confirm-add-email`, body, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'emailAdded') {
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}

// Maps the per-client `ssoType` (see clientConfig.js) to its auth endpoint.
// Add a new entry here to support another SSO variant.
const SSO_ENDPOINTS = {
  visit: '/new-auth/visit-sso',
  universal: '/new-auth/universal-sso',
  retail: '/new-auth/retail/sso',
  abw: '/new-auth/abw/sso',
};

/**
 * @param {Object} [userDetails] - Encrypted profile fields, sent when completing
 *   an SSO login that the backend answered with `screen: 'collectUserDetails'`.
 */
export function ssoLogin(
  encrypted,
  clientId,
  data,
  ssoType = 'visit',
  userDetails
) {
  let body = {
    encrypted,
    clientId,
  };

  if (data) {
    body = {
      data,
      clientId,
    };
  }

  if (userDetails) {
    body.userDetails = userDetails;
  }

  const path = SSO_ENDPOINTS[ssoType] || SSO_ENDPOINTS.visit;

  return axios
    .post(`${config.apiBaseUrl}${path}`, body, {
      withCredentials: true,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (
        responseBody.screen === 'collectUserDetails' ||
        responseBody.message === 'success'
      ) {
        return {
          headers: resp.headers,
          body: resp.data,
        };
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}

export function callMetaApi(authToken) {
  const headers = {
    authorization: authToken,
  };
  const params = {
    version: config.version,
  };
  return axios
    .get(`${config.apiBaseUrl}/users/meta`, {
      params,
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return {
          headers: resp.headers,
          body: resp.data,
        };
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}

export const getPubnubToken = async (sourceId, action) => {
  try {
    const isChatOnly = store.getState().app.tatva || false;

    const headers = {
      authorization: store.getState().user.authToken,
    };
    const params = {
      sourceId,
      action,
    };

    const url = isChatOnly
      ? `${config.pbChatBaseUrl}/tele/pubnub/token`
      : `${config.apiBaseUrl}/pubnub/user/token`;

    const res = await axios.get(url, {
      params,
      headers,
    });
    const responseBody = res.data;
    if (responseBody.message === 'success') {
      return responseBody.data.userToken;
    }
    const err = new Error('Invalid response');
    err.data = responseBody;
    throw err;
  } catch (err) {
    showError('Error in fetching PubNub token', err);
  }
};

export const refreshAuthToken = (authToken) => {
  // Get the current (expired) auth token to send with refresh request
  const currentAuthToken = store.getState().user.authToken || authToken;

  // With HTTP-only cookies, we don't need to manually send the refresh token
  // The browser will automatically include it in the request
  // Use separate axios instance to avoid interceptor loops
  return refreshAxiosInstance
    .post(
      `/new-auth/user/refresh`,
      {},
      {
        headers: {
          // Send the current (expired) auth token for validation
          Authorization: currentAuthToken,
        },
        withCredentials: true, // This ensures cookies are sent
      }
    )
    .then((resp) => {
      const responseBody = resp.data;
      const responseHeaders = resp.headers;

      if (responseBody.message === 'success') {
        return {
          headers: responseHeaders,
          body: responseBody,
        };
      }

      const err = new Error('Refresh token expired or invalid');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      console.log('Refresh token failed:', err);
      throw err;
    });
};

/**
 * Mints a one-time token (OTT) the caller can put in a redirect URL in
 * place of the raw JWT.
 *
 * @async
 * @function mintAuthOtt
 * @param {string} authToken - The current auth token ("jwt <jwt>" or "Bearer <jwt>") sent as the Authorization header.
 * @param {string} flow - The flow scope. One of 'payment', 'manageDependent'.
 * @returns {Promise<string|null>} The 32-char hex OTT on success, or null on any failure so callers can fall back to the legacy `?auth=` redirect during the cutover.
 * @description Best-effort. Callers MUST treat a null return as a signal to use the legacy auth-in-URL flow — the backend route keeps accepting `?auth=` until that gate is closed in a follow-up ticket.
 */
export function mintAuthOtt(authToken, flow) {
  if (!authToken) return Promise.resolve(null);
  return axios
    .post(
      `${config.apiBaseUrl}/new-auth/mint-ott`,
      { flow },
      { headers: { authorization: authToken } }
    )
    .then((resp) => (resp && resp.data && resp.data.ott) || null)
    .catch((err) => {
      console.warn('mintAuthOtt failed', err && err.message);
      return null;
    });
}

export function authLogout(authToken) {
  const headers = {
    authorization: authToken,
  };

  return refreshAxiosInstance
    .post(
      `${config.apiBaseUrl}/new-auth/user/logout`,
      {},
      {
        headers,
      }
    )
    .then((resp) => {
      console.log('Logout', resp);
    })
    .catch((err) => {
      console.error('Error during logout:', err);
    });
}
